import React, { Component } from "react";
import "../../Controls/ListingPage.css";
import Input from "../../Controls/Input";
import TransactionalTemplates from "./TransactionalTemplates";
import PromotionalTemplates from "./PromotionalTemplates";

class Template extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      activeTab: "transactional"
    };

    this.setActiveTab = this.setActiveTab.bind(this);
  }

  setActiveTab(tab) {
    this.setState({ activeTab: tab });
  }

  render() {
    const { providerName, providerId } = this.props.match.params;

    const registrationData =
      this.props.registration && this.props.registration.registration
        ? this.props.registration.registration
        : {};

    const isTransactionalActive = this.state.activeTab === "transactional";
    const isPromotionalActive = this.state.activeTab === "promotional";

    const buttonStyle = (active) => ({
      padding: "8px 16px",
      borderRadius: "8px",
      fontSize: "14px",
      fontWeight: "600",
      cursor: "pointer",
      transition: "all 0.2s",
      marginRight: "10px",
      border: active ? "none" : "1px solid #e2e8f0",
      backgroundColor: active ? "#2563eb" : "#ffffff",
      color: active ? "#ffffff" : "#334155",
      boxShadow: active ? "0 2px 6px rgba(0,0,0,0.1)" : "none"
    });

    const headerTabs =
      providerName !== "Posible" && (
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onClick={() => this.setActiveTab("transactional")}
            style={buttonStyle(isTransactionalActive)}
          >
            Transactional
          </button>

          <button
            onClick={() => this.setActiveTab("promotional")}
            style={buttonStyle(isPromotionalActive)}
          >
            Promotional
          </button>
        </div>
      );

    return (
      <div className="header-margin">
        <div style={{ padding: "10px" }}>
          <div className="listing-page-header">
            <div className="left left-40">
              <div className="listing-page-header-title">
                Templates for {providerName}
              </div>
            </div>
          </div>

          <div
            className="listing-page-content"
            style={{
              padding: "10px",
              height: window.innerHeight - 100 + "px",
              overflowY: "auto",
              backgroundColor: "white",
              borderBottomLeftRadius: "12px",
              borderBottomRightRadius: "12px"
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                height: "100%",
                overflow: "hidden"
              }}
            >
              <div style={{ padding: "12px 12px 0 12px" }}>
                {headerTabs}
              </div>

              <div
                style={{
                  flex: 1,
                  overflowY: "auto",
                  padding: "12px"
                }}
                className=""
              >
                {this.state.activeTab === "transactional" ? (
                  <TransactionalTemplates
                    {...this.props}
                    providerId={providerId}
                    providerName={providerName}
                    templateType={this.state.activeTab}
                    registrationId={registrationData.key}
                    isPosible={providerName === "Posible"}
                  />
                ) : (
                  <PromotionalTemplates
                    {...this.props}
                    providerId={providerId}
                    providerName={providerName}
                    templateType={this.state.activeTab}
                    registrationId={registrationData.key}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Template;